import { useEffect } from 'react';

declare global {
  interface Window {
    embeddedservice_bootstrap: {
      settings: {
        language: string;
      };
      init: (...args: unknown[]) => void;
    };
  }
}

const SalesforceChatScript = () => {
  useEffect(() => {
    const salesforceCallback = function initEmbeddedMessaging() {
      try {
        window.embeddedservice_bootstrap.settings.language = 'en_US';

        window.embeddedservice_bootstrap.init(
          '00DS8000001nbyl',
          'MND_Website_Support_Chat',
          'https://mynewsdesk--mndsandbox.sandbox.my.site.com/ESWMNDWebsiteSupportCh1729760060504',
          {
            scrt2URL: 'https://mynewsdesk--mndsandbox.sandbox.my.salesforce-scrt.com',
          },
        );
      } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
      }
    };
    const script = document.createElement('script');
    script.src =
      'https://mynewsdesk--mndsandbox.sandbox.my.site.com/ESWMNDWebsiteSupportCh1729760060504/assets/js/bootstrap.min.js';
    script.addEventListener('load', salesforceCallback);

    document.body.appendChild(script);
  }, []);

  return null;
};

export default SalesforceChatScript;
